import React from "react";
import classes from './list.module.css';

const List = (props) => {
    return(
        <li className={classes.listLi}>{props.list.list}</li>
    )
}

export default List;